import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import InsertLink from "@mui/icons-material/InsertLink";
import { IconButton, Tooltip } from "@mui/material";
import { COMMAND_PRIORITY_LOW, SELECTION_CHANGE_COMMAND } from "lexical";
import { type FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import type { EditorModalState } from "../../lexical-context";
import { $multipleElementsSelected } from "../../utils/multiple-elements-selected";
import { floatingToolbarStyles } from "./floating-toolbar-styles";
import { useLinkButtonOnClick } from "./hooks/use-link-button-on-click";
import type { ToolbarProps } from "./props";

export const LinkButton: FC<
  ToolbarProps & {
    handleOpen: (data: EditorModalState) => void;
    active: boolean;
  }
> = ({ handleOpen, disabled, mode, active }) => {
  const [forceDisabled, setForceDisabled] = useState(false);

  const { t } = useTranslation();
  const [editor] = useLexicalComposerContext();

  const linkButtonOnClick = useLinkButtonOnClick(editor, handleOpen);

  useEffect(
    () =>
      editor.registerCommand(
        SELECTION_CHANGE_COMMAND,
        () => {
          setForceDisabled($multipleElementsSelected());

          return false;
        },
        COMMAND_PRIORITY_LOW,
      ),
    [editor],
  );

  return (
    <>
      <Tooltip title={t("Link")}>
        <IconButton
          data-analytics-id={`lexical-${mode}-link`}
          disabled={disabled || forceDisabled}
          data-testid={`${mode}-button-link`}
          aria-label="Link"
          data-active={active}
          aria-pressed={active}
          tabIndex={-1}
          onClick={linkButtonOnClick}
          sx={{
            ...floatingToolbarStyles[mode].button,
            backgroundColor: active ? "background.active" : "background.neutral",
          }}
        >
          <InsertLink sx={floatingToolbarStyles[mode].formatIcon} />
        </IconButton>
      </Tooltip>
    </>
  );
};
